import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
//import * as apiUser from 'apiSaga/apiUser';
import * as apiDocument from 'apiSaga/apiDocument';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_ADMIN_RESP = 'docu/INIT_ADMIN_RESP';
const INIT_DOCU_CODE_LIST_RESP = 'docu/INIT_DOCU_CODE_LIST_RESP'; //문서코드 초기화
const INIT_DISTRIBUTOR_LIST_RESP = 'docu/INIT_DISTRIBUTOR_LIST_RESP'; // 유통사코드 초기화
const INIT_USER_CODE_LIST_RESP = 'docu/INIT_USER_CODE_LIST_RESP'; //고객코드 초기화
const INIT_GET_DOCU_LIST_RESP = 'docu/INIT_GET_DOCU_LIST_RESP'; //문서조회 초기화
const INIT_GET_DOCU_DETAIL_RESP = 'docu/INIT_GET_DOCU_DETAIL_RESP'; //문서상세 초기화
const INIT_DOCU_LIST_FILE_DOWN_RESP = 'docu/INIT_DOCU_LIST_FILE_DOWN_RESP'; // 목록 조회 텍스트 저장
const INIT_DOCU_LIST_EXCEL_DOWN_RESP = 'docu/INIT_DOCU_LIST_EXCEL_DOWN_RESP'; //목록 조회 엑셀 저장

const INIT_DOCU_DETAIL_FILE_DOWN_RESP = 'docu/INIT_DOCU_LIST_FILE_DOWN_RESP'; // 목록 상세조회 텍스트 저장
const INIT_DOCU_DETAIL_EXCEL_DOWN_RESP = 'docu/INIT_DOCU_LIST_EXCEL_DOWN_RESP'; //목록 상세조회 엑셀 저장

const INIT_DOCU_ALL_EXCEL_DOWN_RESP = 'docu/INIT_DOCU_LIST_EXCEL_DOWN_RESP'; //목록 전체조회 엑셀 저장

// 1. 문서 타입 코드 조회
const GET_DOCU_CODE_LIST = 'docu/GET_DOCU_CODE_LIST';
const GET_DOCU_CODE_LIST_SUCCESS = 'docu/GET_DOCU_CODE_LIST_SUCCESS';
const GET_DOCU_CODE_LIST_FAILURE = 'docu/GET_DOCU_CODE_LIST_FAILURE';
// 2. 유통사코드 조회 -- 문서 조회조건에 유통사 상위조건 추가 21/06/28
const GET_DISTRIBUTOR_LIST = 'docu/GET_DISTRIBUTOR_LIST';
const GET_DISTRIBUTOR_LIST_SUCCESS = 'docu/GET_DISTRIBUTOR_LIST_SUCCESS';
const GET_DISTRIBUTOR_LIST_FAILURE = 'docu/GET_DISTRIBUTOR_LIST_FAILURE';
// 2. 유통사코드 조회 -- 3PL
const GET_DISTRIBUTOR_3PL_LIST = 'docu/GET_DISTRIBUTOR_3PL_LIST';
const GET_DISTRIBUTOR_3PL_LIST_SUCCESS = 'docu/GET_DISTRIBUTOR_3PL_LIST_SUCCESS';
const GET_DISTRIBUTOR_3PL_LIST_FAILURE = 'docu/GET_DISTRIBUTOR_3PL_LIST_FAILURE';
// 2. 제조사코드 조회 -- 3PL
const GET_MANUFACTURER_3PL_LIST = 'docu/GET_MANUFACTURER_3PL_LIST';
const GET_MANUFACTURER_3PL_LIST_SUCCESS = 'docu/GET_MANUFACTURER_3PL_LIST_SUCCESS';
const GET_MANUFACTURER_3PL_LIST_FAILURE = 'docu/GET_MANUFACTURER_3PL_LIST_FAILURE';
// 고객코드 조회
const GET_USER_CODE_LIST = 'docu/GET_USER_CODE_LIST';
const GET_USER_CODE_LIST_SUCCESS = 'docu/GET_USER_CODE_LIST_SUCCESS';
const GET_USER_CODE_LIST_FAILURE = 'docu/GET_USER_CODE_LIST_FAILURE';
//문서 조회
const GET_DOCU_LIST = 'docu/GET_DOCU_LIST';
const GET_DOCU_LIST_SUCCESS = 'docu/GET_DOCU_LIST_SUCCESS';
const GET_DOCU_LIST_FAILURE = 'docu/GET_DOCU_LIST_FAILURE';
//문서 상세조회
const GET_DOCU_DETAIL = 'docu/GET_DOCU_DETAIL';
const GET_DOCU_DETAIL_SUCCESS = 'docu/GET_DOCU_DETAIL_SUCCESS';
const GET_DOCU_DETAIL_FAILURE = 'docu/GET_DOCU_DETAIL_FAILURE';
// 파일다운로드
const GET_DOCU_LIST_FILE_DOWN = 'docu/GET_DOCU_LIST_FILE_DOWN';
const GET_DOCU_LIST_FILE_DOWN_SUCCESS = 'docu/GET_DOCU_LIST_FILE_DOWN_SUCCESS';
const GET_DOCU_LIST_FILE_DOWN_FAILURE = 'docu/GET_DOCU_LIST_FILE_DOWN_FAILURE';
// 엑셀다운로드
const GET_DOCU_LIST_EXCEL_DOWN = 'docu/GET_DOCU_LIST_EXCEL_DOWN';
const GET_DOCU_LIST_EXCEL_DOWN_SUCCESS = 'docu/GET_DOCU_LIST_EXCEL_DOWN_SUCCESS';
const GET_DOCU_LIST_EXCEL_DOWN_FAILURE = 'docu/GET_DOCU_LIST_EXCEL_DOWN_FAILURE';

// 파일다운로드
const GET_DOCU_DETAIL_FILE_DOWN = 'docu/GET_DOCU_DETAIL_FILE_DOWN';
const GET_DOCU_DETAIL_FILE_DOWN_SUCCESS = 'docu/GET_DOCU_DETAIL_FILE_DOWN_SUCCESS';
const GET_DOCU_DETAIL_FILE_DOWN_FAILURE = 'docu/GET_DOCU_DETAIL_FILE_DOWN_FAILURE';
// 엑셀다운로드
const GET_DOCU_DETAIL_EXCEL_DOWN = 'docu/GET_DOCU_DETAIL_EXCEL_DOWN';
const GET_DOCU_DETAIL_EXCEL_DOWN_SUCCESS = 'docu/GET_DOCU_DETAIL_EXCEL_DOWN_SUCCESS';
const GET_DOCU_DETAIL_EXCEL_DOWN_FAILURE = 'docu/GET_DOCU_DETAIL_EXCEL_DOWN_FAILURE';
// 엑셀다운로드
const GET_DOCU_DETAIL_ALL_EXCEL_DOWN = 'docu/GET_DOCU_DETAIL_ALL_EXCEL_DOWN';
const GET_DOCU_DETAIL_ALL_EXCEL_DOWN_SUCCESS = 'docu/GET_DOCU_DETAIL_ALL_EXCEL_DOWN_SUCCESS';
const GET_DOCU_DETAIL_ALL_EXCEL_DOWN_FAILURE = 'docu/GET_DOCU_DETAIL_ALL_EXCEL_DOWN_FAILURE';
// 엑셀전체다운로드
const GET_DOCU_ALL_EXCEL_DOWN = 'docu/GET_DOCU_ALL_EXCEL_DOWN';
const GET_DOCU_ALL_EXCEL_DOWN_SUCCESS = 'docu/GET_DOCU_ALL_EXCEL_DOWN_SUCCESS';
const GET_DOCU_ALL_EXCEL_DOWN_FAILURE = 'docu/GET_DOCU_ALL_EXCEL_DOWN_FAILURE';

// 0. Response 초기화
export const initUserResp = createAction(INIT_ADMIN_RESP);
export const initDocuCodeListResp = createAction(INIT_DOCU_CODE_LIST_RESP); //문서코드 response 초기화
export const initDistributorListResp = createAction(INIT_DISTRIBUTOR_LIST_RESP); // 유통사코드 response 초기화
export const initUserCodeListResp = createAction(INIT_USER_CODE_LIST_RESP); //고객코드 response 초기화
export const initDocumentListResp = createAction(INIT_GET_DOCU_LIST_RESP); //문서조회 response 초기화
export const initDocumentDetailResp = createAction(INIT_GET_DOCU_DETAIL_RESP); //문서상세 response 초기화
export const initDocuListFileDownResp = createAction(INIT_DOCU_LIST_FILE_DOWN_RESP); //CSV 다운로드 response 초기화
export const initDocuListExcelDownResp = createAction(INIT_DOCU_LIST_EXCEL_DOWN_RESP); //엑셀 다운로드 response 초기화

export const initDocuDetailFileDownResp = createAction(INIT_DOCU_DETAIL_FILE_DOWN_RESP); //CSV 다운로드 response 초기화
export const initDocuDetailExcelDownResp = createAction(INIT_DOCU_DETAIL_EXCEL_DOWN_RESP); //엑셀 다운로드 response 초기화

export const initDocuAllExcelDownResp = createAction(INIT_DOCU_LIST_EXCEL_DOWN_RESP); //엑셀 전체 다운로드 response 초기화

// 1. 문서 타입 코드 조회
export const getDocuCodeList = createAction(GET_DOCU_CODE_LIST, (sysGroupCode) => sysGroupCode);
// 2.유통사코드 조회
export const getDistributorList = createAction(GET_DISTRIBUTOR_LIST, (sysGroupCode) => sysGroupCode);

// 2.유통사코드 조회(3PL)
export const getDistributor3PlList = createAction(GET_DISTRIBUTOR_3PL_LIST, (sysGroupCode) => sysGroupCode);

// 3.제조사코드 조회(3PL)
export const getManufacturer3PlList = createAction(GET_MANUFACTURER_3PL_LIST, (sysGroupCode) => sysGroupCode);

export const getUserCodeList = createAction(GET_USER_CODE_LIST, (documentinfo) => documentinfo);
export const getDocumentList = createAction(
  //문서조회
  GET_DOCU_LIST,
  (documentinfo) => documentinfo
);
export const getDocumentDetail = createAction(
  //문서상세조회
  GET_DOCU_DETAIL,
  (documentinfo) => documentinfo
);
//파일다운로드
export const getDocuListFileDown = createAction(GET_DOCU_LIST_FILE_DOWN, (documentinfo) => documentinfo);
//액샐다운로드
export const getDocuListExcelDown = createAction(GET_DOCU_LIST_EXCEL_DOWN, (documentinfo) => documentinfo);

//파일다운로드
export const getDocuDetailFileDown = createAction(GET_DOCU_DETAIL_FILE_DOWN, (documentinfo) => documentinfo);
//액샐다운로드
export const getDocuDetailExcelDown = createAction(GET_DOCU_DETAIL_EXCEL_DOWN, (documentinfo) => documentinfo);
//액샐다운로드
export const getDocuDetailALLExcelDown = createAction(GET_DOCU_DETAIL_ALL_EXCEL_DOWN, (documentinfo) => documentinfo);
//액샐전체다운로드
export const getDocuAllExcelDown = createAction(GET_DOCU_ALL_EXCEL_DOWN, (documentinfo) => documentinfo);

const getDocuCodeListSaga = createRequestSaga(GET_DOCU_CODE_LIST, apiDocument.getDocuCodeList); //문서코드
const getDistributorListSaga = createRequestSaga(GET_DISTRIBUTOR_LIST, apiDocument.getDistributorList); //유통사목록 조회
const getDistributor3PlListSaga = createRequestSaga(GET_DISTRIBUTOR_3PL_LIST, apiDocument.getDistributor3PlList); //유통사목록 조회(3PL)
const getManufacturer3PlListSaga = createRequestSaga(GET_MANUFACTURER_3PL_LIST, apiDocument.getManufacturer3PlList); //제조사목록 조회(3PL)
const getUserCodeListSaga = createRequestSaga(GET_USER_CODE_LIST, apiDocument.getUserCodeList); //고객코드
const getDocumentListSaga = createRequestSaga(GET_DOCU_LIST, apiDocument.getDocumentList); //문서조회saga
const getDocumentDetailSaga = createRequestSaga(GET_DOCU_DETAIL, apiDocument.getDocumentDetail); //문서상세조회saga
const getDocuListFileDownSaga = createRequestSaga(GET_DOCU_LIST_FILE_DOWN, apiDocument.getDocuListFileDown); //파일다운로드saga
const getDocuListExcelDownSaga = createRequestSaga(GET_DOCU_LIST_EXCEL_DOWN, apiDocument.getDocuListExcelDown); //엑셀다운로드saga

const getDocuDetailFileDownSaga = createRequestSaga(GET_DOCU_DETAIL_FILE_DOWN, apiDocument.getDocuDetailFileDown); //파일다운로드saga
const getDocuDetailExcelDownSaga = createRequestSaga(GET_DOCU_DETAIL_EXCEL_DOWN, apiDocument.getDocuDetailExcelDown); //엑셀다운로드saga
const getDocuDetailAllExcelDownSaga = createRequestSaga(GET_DOCU_DETAIL_ALL_EXCEL_DOWN, apiDocument.getDocuDetailAllExcelDown); //엑셀다운로드(상세-전체)saga

const getDocuAllExcelDownSaga = createRequestSaga(GET_DOCU_ALL_EXCEL_DOWN, apiDocument.getDocuAllExcelDown); //엑셀전체다운로드saga

// apiUserSaga
export function* apiDocumentSaga() {
  yield takeLatest(GET_DOCU_CODE_LIST, getDocuCodeListSaga);
  yield takeLatest(GET_DISTRIBUTOR_LIST, getDistributorListSaga);
  yield takeLatest(GET_DISTRIBUTOR_3PL_LIST, getDistributor3PlListSaga);
  yield takeLatest(GET_MANUFACTURER_3PL_LIST, getManufacturer3PlListSaga);
  yield takeLatest(GET_USER_CODE_LIST, getUserCodeListSaga);
  yield takeLatest(GET_DOCU_LIST, getDocumentListSaga);
  yield takeLatest(GET_DOCU_DETAIL, getDocumentDetailSaga);
  yield takeLatest(GET_DOCU_LIST_FILE_DOWN, getDocuListFileDownSaga);
  yield takeLatest(GET_DOCU_LIST_EXCEL_DOWN, getDocuListExcelDownSaga);
  yield takeLatest(GET_DOCU_DETAIL_FILE_DOWN, getDocuDetailFileDownSaga);
  yield takeLatest(GET_DOCU_DETAIL_EXCEL_DOWN, getDocuDetailExcelDownSaga);
  yield takeLatest(GET_DOCU_DETAIL_ALL_EXCEL_DOWN, getDocuDetailAllExcelDownSaga);
  yield takeLatest(GET_DOCU_ALL_EXCEL_DOWN, getDocuAllExcelDownSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getDocuCodeListResp: null,
  getDistributorListResp: null,
  getDistributor3PlListResp: null,
  getManufacturer3PlListResp: null,
  getUserCodeListResp: null,
  getDocumentListResp: null,
  getDocumentDetailResp: null,
  getDocuListFileDownResp: null,
  getDocuListExcelDownResp: null,
  getDocuDetailFileDownResp: null,
  getDocuDetailExcelDownResp: null,
  getDocuDetailAllExcelDownResp: null,
  getDocuAllExcelDownResp: null,
  initDocuListExcelDownResp: null,
  initDocuAllExcelDownResp: null,
};

const apiDocumentResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_ADMIN_RESP]: (state, action) => ({
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_CODE_LIST_RESP]: (state, action) => ({
      //문서관리
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DISTRIBUTOR_LIST_RESP]: (state, action) => ({
      //유통사목록
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_USER_CODE_LIST_RESP]: (state, action) => ({
      //문서관리
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_GET_DOCU_LIST_RESP]: (state, action) => ({
      //주문조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_GET_DOCU_DETAIL_RESP]: (state, action) => ({
      //문서상세조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_LIST_FILE_DOWN_RESP]: (state, action) => ({
      //문서상세조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_LIST_EXCEL_DOWN_RESP]: (state, action) => ({
      //문서상세조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_DETAIL_FILE_DOWN_RESP]: (state, action) => ({
      //문서상세조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_DETAIL_EXCEL_DOWN_RESP]: (state, action) => ({
      //문서상세조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),
    [INIT_DOCU_ALL_EXCEL_DOWN_RESP]: (state, action) => ({
      //문서전체조회
      ...state,
      getDocuCodeListResp: null,
      getDistributorListResp: null,
      getDistributor3PlListResp: null,
      // getManufacturer3PlListResp: null,
      getUserCodeListResp: null,
      getDocumentListResp: null,
      getDocumentDetailResp: null,
      getDocuListFileDownResp: null,
      getDocuListExcelDownResp: null,
      getDocuDetailFileDownResp: null,
      getDocuDetailExcelDownResp: null,
      getDocuDetailAllExcelDownResp: null,
      getDocuAllExcelDownResp: null,
      initDocuListExcelDownResp: null,
      initDocuAllExcelDownResp: null,
    }),

    // 1. 문서조회 타입 코드 조회
    [GET_DOCU_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDocuCodeListResp: action.payload,
    }),
    [GET_DOCU_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDocuCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 1. 유통사 조회 타입 코드 조회
    [GET_DISTRIBUTOR_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDistributorListResp: action.payload,
    }),
    [GET_DISTRIBUTOR_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDistributorListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 1. 유통사 조회 타입 코드 조회(3PL)
    [GET_DISTRIBUTOR_3PL_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDistributor3PlListResp: action.payload,
    }),
    [GET_DISTRIBUTOR_3PL_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDistributor3PlListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 1. 제조사 조회 타입 코드 조회(3PL)
    [GET_MANUFACTURER_3PL_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getManufacturer3PlListResp: action.payload,
    }),
    [GET_MANUFACTURER_3PL_LIST_FAILURE]: (state, action) => ({
      ...state,
      getManufacturer3PlListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 1. 고객조회 코드 조회
    [GET_USER_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUserCodeListResp: action.payload,
    }),
    [GET_USER_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUserCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 문서 목록 조회
    [GET_DOCU_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDocumentListResp: action.payload,
    }),
    [GET_DOCU_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDocumentListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 문서 상세 조회
    [GET_DOCU_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      getDocumentDetailResp: action.payload,
    }),
    [GET_DOCU_DETAIL_FAILURE]: (state, action) => ({
      ...state,
      getDocumentDetailResp: {
        code: 'E999',
        message: action.payload,
      },
    }),

    // 파일다운로드
    [GET_DOCU_LIST_FILE_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuListFileDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_LIST_FILE_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuListFileDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),
    // 엑셀다운로드
    [GET_DOCU_LIST_EXCEL_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuListExcelDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_LIST_EXCEL_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuListExcelDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),

    // 파일다운로드
    [GET_DOCU_DETAIL_FILE_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuDetailFileDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_DETAIL_FILE_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuDetailFileDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),
    // 엑셀다운로드
    [GET_DOCU_DETAIL_EXCEL_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuDetailExcelDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_DETAIL_EXCEL_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuDetailExcelDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),
    // 엑셀다운로드(상세-전체)
    [GET_DOCU_DETAIL_ALL_EXCEL_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuDetailAllExcelDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_DETAIL_ALL_EXCEL_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuDetailAllExcelDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),
    // 엑셀전체다운로드
    [GET_DOCU_ALL_EXCEL_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      getDocuAllExcelDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_DOCU_ALL_EXCEL_DOWN_FAILURE]: (state, action) => ({
      ...state,
      getDocuAllExcelDownResp: {
        result_code: 'E999',
        result_message: action.payload,
      },
    }),
    //
  },
  initialState
);

export default apiDocumentResp;
